import React, { useEffect, useState } from "react";

import { fileUpload, incomplete } from "utils";

import { AdminSection, AdminTable, Button, Col, Form, Input, InputNumber, Row, TextArea, UploadImage } from "components";

export const ModuleQuotes = ({ module, quotes, setQuotes }) => {
  const [updatedQuotes, setUpdatedQuotes] = useState([...quotes]);
  const [selectedQuote, setSelectedQuote] = useState(null);
  const [imageURL, setImageURL] = useState(false);
  const [imageSuccess, setImageSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const removeQuote = (i) => {
    const arr = updatedQuotes;
    arr.splice(i, 1);
    setUpdatedQuotes([...arr]);

    if (selectedQuote) {
      setSelectedIndex(null);
    }
  };

  const complete = (v) => {
    setLoading(true);

    const newQuote = {
      moduleId: module.id,
      farmerName: v.farmerName,
      image: imageURL,
      region: v.region,
      hectares: v.hectares,
      quote: v.quote,
      key: updatedQuotes.length,
    };

    const newQuotes = updatedQuotes;
    newQuotes.push(newQuote);

    if (selectedQuote && selectedQuote.key) {
      newQuotes.splice(selectedQuote.key, 1);
    }

    setUpdatedQuotes(newQuotes);
    setQuotes(newQuotes);
    setSelectedIndex(null);
    setImageURL(false);
    setSelectedQuote(null);
  };

  useEffect(() => {
    setLoading(true);

    if (selectedIndex !== null) {
      setSelectedQuote(updatedQuotes[selectedIndex]);
      setImageURL(updatedQuotes[selectedIndex].image ? updatedQuotes[selectedIndex].image : null);
    } else {
      setSelectedQuote(null);
      setImageURL(null);
    }
  }, [selectedIndex]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setLoading(false);
  }, [selectedQuote]);

  return (
    <>
      <AdminSection
        headline="Manage farmer quotes"
        description={
          <>
            Add a new quote below, or edit existing quotes in the table.{" "}
            <span className="red-text paragraph-m-bold">Don't forget to save the module after editing quotes.</span>
          </>
        }
      />
      <Row>
        <Col>
          {!loading && (
            <Form name="confirm" onFinish={complete} onFinishFailed={incomplete}>
              <Row>
                <Col>
                  <Form.Item name="quoteImage" initialValue={selectedQuote ? selectedQuote.image : undefined}>
                    <UploadImage
                      imageSuccess={imageSuccess}
                      imageUrl={imageURL}
                      label="Add image"
                      beforeUpload={(v) => fileUpload(v, "modules", setImageSuccess, setImageURL, setLoading)}
                    />
                  </Form.Item>
                </Col>
                <Col lg={14}>
                  <Input
                    name="farmerName"
                    label="Farmer name"
                    className="no-suffix"
                    rules={[{ required: true }]}
                    initialValue={selectedQuote ? selectedQuote.farmerName : undefined}
                    onChange={(v) =>
                      setSelectedQuote({
                        ...selectedQuote,
                        farmerName: v.target.value,
                      })
                    }
                  />
                </Col>
                <Col lg={6}>
                  <Input
                    name="region"
                    label="Region"
                    className="no-suffix"
                    rules={[{ required: true }]}
                    initialValue={selectedQuote ? selectedQuote.region : undefined}
                    onChange={(v) =>
                      setSelectedQuote({
                        ...selectedQuote,
                        region: v.target.value,
                      })
                    }
                  />
                </Col>
                <Col lg={4}>
                  <InputNumber
                    name="hectares"
                    label="Hectares"
                    rules={[{ required: true }]}
                    initialValue={selectedQuote ? selectedQuote.hectares : undefined}
                    suffix="ha"
                    onChange={(v) => setSelectedQuote({ ...selectedQuote, hectares: v })}
                  />
                </Col>
                <Col lg={24}>
                  <TextArea
                    name="quote"
                    label="Quote"
                    rules={[{ required: true }]}
                    autoSize
                    initialValue={selectedQuote ? selectedQuote.quote : undefined}
                    onChange={(v) =>
                      setSelectedQuote({
                        ...selectedQuote,
                        quote: v.target.value,
                      })
                    }
                  />
                </Col>
                <Col>
                  {selectedQuote && selectedQuote.key ? (
                    <Button type="secondary" htmlType="submit">
                      Update this quote
                    </Button>
                  ) : (
                    <Button type="secondary" htmlType="submit">
                      Add this quote
                    </Button>
                  )}
                </Col>
              </Row>
            </Form>
          )}
        </Col>
      </Row>

      <Row>
        <Col>
          {!loading && (
            <AdminTable
              dataSource={updatedQuotes}
              config={{
                exclude: ["quote", "image", "moduleId", "key", "id"],
                actions: [
                  {
                    icon: "tabler/edit",
                    func: (v) => setSelectedIndex(v.key),
                    tooltip: "Edit this quote",
                  },
                  {
                    icon: "tabler/trash",
                    func: (v) => removeQuote(v.key),
                    tooltip: "Delete this quote",
                  },
                ],
              }}
            />
          )}
        </Col>
      </Row>
      <Row>
        <Col>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Save module
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};
